module.exports = __webpack_public_path__ + "static/img/11_1Intro_8_Kaprow_RoutineFilmStill_FPO.8ed3b15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/kaprow/images/11_1Intro_8_Kaprow_RoutineFilmStill_FPO.jpg
// module id = uvm+
// module chunks = 0